import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"
import store from "./store";
import VueCookies from 'vue3-cookies';
import "./assets/css/bootstrap.min.css";
import "./assets/css/chat.css";
import "./assets/css/chatresponsive.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/fontawesome/css/all.css";
import "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import './registerServiceWorker';
import globalProperties from './globalServices';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
import { errorToast } from "@/shared/services/helper";
import { setHeaders } from "@/shared/services/headers";
import { apiCall } from "@/shared/services/apiCall";
import { AUTH_TOKEN } from "./shared/constants/cookies-const";

const initialAuthToken = cookies.get(AUTH_TOKEN);
window.authorization_token = initialAuthToken ? `Bearer ${initialAuthToken}` : null;
setHeaders();

const getMultiTemplateAuth = async(routeData) => {
    try{
        window.authorization_token = `Bearer ${routeData.query.auth}`;
        store.dispatch('setToken', `Bearer ${routeData.query.auth}`);
        setHeaders();
        let response = await apiCall('get', 'GET_USER_INFO');
        if (response && response.status == 200) {
            if (response?.data?.status == 0 || response?.data?.error || response?.data?.msg) {
                errorToast(response?.data?.error);
            } else {
                setUserDataToStore(response.data);
                location.reload();
                store.state.auth.user.token = routeData.query.auth;
            }
        }
        return
    }
    catch(error){
        console.log(error);
        errorToast(error || 'Something went wrong')
    }
};
const setUserDataToStore = async (userData) => {
        let user = {
            notificationSubscribed: null,
            notificationUnsubscribed: null,
            isDemo: userData?.demo || false
        }
        store.dispatch('setUser', {...userData?.user, ...user});
        store.dispatch('setChips', userData?.user?.chips);
        store.dispatch('setEventManage', userData?.event_manage);
};

router.beforeEach(async (to, from, next) => {
    const isLoggedIn = store.getters.isAuthenticated;
    const lastLoginAt = store.getters.stateUser?.last_login_at;
    const underMaintenance = store.getters.underMaintenance;
    const isMaintenancePage = to.name === 'Maintenance';
    const isResetPasswordPage = to.name === 'changePassword';

     if (to.query.auth && !isLoggedIn) {
        await getMultiTemplateAuth(to);
        cookies.set('AUTH_TOKEN', to.query.auth);
        return next({ name: 'Home' });
    }

    if (underMaintenance) {
        if (!isMaintenancePage) {
            next({ name: 'Maintenance' });
        } else {
            next();
        }
    } else {
        if (isMaintenancePage) {
            next({ name: 'Home' });
        } else if (isLoggedIn && !lastLoginAt && !isResetPasswordPage) {
            next({ name: 'changePassword' })
        } else {
            next();
        }
    }
});

router.afterEach(() => {
    setTimeout(() => {
        window.scrollTo({ top: 0 });
    }, 500);
});
const app = createApp(App);
async function initApp() {
    app.use(globalProperties);
    app.use(store);
    app.use(router);
    app.use(VueCookies);
    await router.isReady();
    app.mount("#app");

};
initApp();
